import React from 'react';

export function JobService() {

	return <div>

		{/* New Issues */}
		<section className='expander expanded'>
			<header><button tabIndex={ -1 }><span>NEW ISSUES <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'></div>
			</header>
			<div className=''>
				
				{/* Inspection */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>05/15/20 <span className='subtitle'>Inspection by Darryl Philbin</span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly editItem disabled'><span></span></button>
							<button className='icon iconOnly moveItem disabled'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className='issue sorted'>No.</td>
										<td className='source'>Source</td>
										<td className='description'>Description</td>
										<td className='estimate'>Estimate</td>
										<td className='material'>Material</td>
										<td className='po'></td>
										<td className='location'></td>
										<td className='action'>Photos</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>12</span></td>
										<td className='source'>Installer</td>
										<td className='description'>Kitchen • Install coffee station hardware</td>
										<td className='estimate'>1 hour</td>
										<td className='material' colSpan={3}>–</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		{/* PROCESS */}
		<section className='expander expanded'>
			<header><button tabIndex={ -1 }><span>PROCESS <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'><button className='icon iconOnly addItemWhite'><span></span></button></div>
			</header>
			<div className=''>

				{/* Material to Order */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>Material to Order <span className='subtitle'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly print'><span></span></button>
							<button className='icon iconOnly editItem disabled'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className='issue sorted'>No.</td>
										<td className='source'>Source</td>
										<td className='description'>Description</td>
										<td className='manufacturer'>Manufacturer</td>
										<td className='material'>Material</td>
										<td className='po'></td>
										<td className='location'></td>
										<td className='action'>Photos</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>2</span></td>
										<td className='source'>Installer</td>
										<td className='description'>Kitchen • Install backsplash doors, left and right of fridge, (need size, after counters are installed)</td>
										<td className='manufacturer'>Kitchen Craft</td>
										<td className='material' colSpan={3}>2-door panels, with backpainted glass (need size)</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>8</span></td>
										<td className='source'>Service</td>
										<td className='description'>Kitchen • Under panel at elevation B need wired mercury ET</td>
										<td className='manufacturer'>Warenhouse</td>
										<td className='material' colSpan={3}>6' ET</td>
										<td className='action'><button className='icon iconOnly photos'><span>1</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>

				{/* Ready to Schedule */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>Ready to Schedule <span className='subtitle'>2 hours</span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly scheduleItem disabled'><span></span></button>
							<button className='icon iconOnly editItem disabled'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className='issue sorted'>No.</td>
										<td className='source'>Source</td>
										<td className='description'>Description</td>
										<td className='estimate'>Estimate</td>
										<td className='material'>Material</td>
										<td className='po'>P.O.</td>
										<td className='location'>Location</td>
										<td className='action'>Photos</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>7</span></td>
										<td className='source'>–</td>
										<td className='description'>Kitchen • Install fridge panels and TK below</td>
										<td className='estimate'>1 hour</td>
										<td className='material'>–</td>
										<td className='po'>–</td>
										<td className='location'>–</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>9</span></td>
										<td className='source'>Cabinet Supplier</td>
										<td className='description'>Kitchen • Install lower shelf, center panel #11 came without glaze 70.5</td>
										<td className='estimate'>1 hour</td>
										<td className='material'>1-WEP11</td>
										<td className='po'>56784</td>
										<td className='location'>Warehouse</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>11</span></td>
										<td className='source'>Installer</td>
										<td className='description'>Kitchen • Replace corner profile filler, came too short need 38 5/8 tall</td>
										<td className='estimate'>–</td>
										<td className='material'>1 door panel</td>
										<td className='po'>56784</td>
										<td className='location'>–</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		{/* SCHEDULED */}
		<section className='expander expanded'>
			<header><button tabIndex={ -1 }><span>Scheduled <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'><button className='icon iconOnly addItemWhite'><span></span></button></div>
			</header>
			<div className=''>

				{/* Visit */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>06/01/20 <span className='subtitle'>3 hours</span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'>
							<button className='icon iconOnly print'><span></span></button>
							<button className='icon iconOnly editItem disabled'><span></span></button>
						</div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className='issue sorted'>No.</td>
										<td className='assignedTo'>Assigned to</td>
										<td className='description'>Description</td>
										<td className='estimate'>Estimate</td>
										<td className='material'>Material</td>
										<td className='po'></td>
										<td className='location'></td>
										<td className='action'>Photos</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>6</span></td>
										<td className='assignedTo'>Bob Smith</td>
										<td className='description'>Kitchen • Install backsplash doors, left and right of fridge, (need size, after counters are installed)</td>
										<td className='estimate'>1 hour</td>
										<td className='material' colSpan={3}>2-door panels, with backpainted glass (need size)</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className="checkboxes"><label><input type="checkbox" /></label></td>
										<td className="issue"><span className='issueNumber'>10</span></td>
										<td className='assignedTo'>Bob Smith</td>
										<td className='description'>Kitchen • Replace corner profile filler, came too short need 38 5/8 tall</td>
										<td className='estimate'>2 hours</td>
										<td className='material' colSpan={3}>Kitchen • Replace corner profile filler, came too short need 38 5/8 tall</td>
										<td className='action'><button className='icon iconOnly photos'><span>2</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		{/* COMPLETED */}
		<section className='expander expanded'>
			<header><button tabIndex={ -1 }><span>Completed <span className='options'></span></span></button>
				<div className='icon iconExpander'><span></span><span></span></div>
				<div className='actions'><button className='icon iconOnly addItemWhite'><span></span></button></div>
			</header>
			<div className=''>

				{/* Visit */}
				<section className='expander expanded'>
					<header><button tabIndex={ -1 }><span>05/05/20 <span className='subtitle'></span></span></button>
						<div className='icon iconExpander'><span></span><span></span></div>
						<div className='actions'></div>
					</header>
					<div>
						<div className='inner clearfix'>
							<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
								<thead>
									<tr>
										<td></td>
										<td className="checkboxes"></td>
										<td className='issue sorted'>No.</td>
										<td className='assignedTo'>Assigned to</td>
										<td className='description'>Description</td>
										<td className='estimate'></td>
										<td className='material'></td>
										<td className='po'></td>
										<td className='location'></td>
										<td className='action'>Photos</td>
										<td className='action'></td>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td></td>
										<td className="checkboxes"></td>
										<td className="issue complete"><span className='issueNumber'>1</span></td>
										<td className='assignedTo'>Bob Smith</td>
										<td className='description' colSpan={5}>Install sink liner</td>
										<td className='action'><button className='icon iconOnly photos'><span>1</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className="checkboxes"></td>
										<td className="issue complete"><span className='issueNumber'>2</span></td>
										<td className='assignedTo'>Bob Smith</td>
										<td className='description' colSpan={5}>Install icemaker panel</td>
										<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
									<tr>
										<td></td>
										<td className="checkboxes"></td>
										<td className="issue complete"><span className='issueNumber'>3</span></td>
										<td className='assignedTo'>Bob Smith</td>
										<td className='description' colSpan={5}>Install roll out, will need to hang center partition, on right side of sink</td>
										<td className='action'><button className='icon iconOnly photos'><span>3</span></button></td>
										<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</section>
			</div>
		</section>

		{/* Add / Edit 1 Issue */}
		<div className='modal out'>
			<div className='window'>
				<header><button className='cancel'><span>Cancel</span></button><span>Edit &bull; 1 Issue</span><button className='save'><span>Save</span></button></header>
				<div className='views'>
					<div className='content in scrollable'>
						<table className='editIssue' cellPadding='0' cellSpacing='0'>
							<tbody>
								<tr>
									<td></td>
									<td><strong>Work Area</strong></td>
									<td>
										<select className="select" placeholder="Select">
											<option value="">Select</option>
											<option value="" selected>Kitchen</option>
											<option value="">Master Bath</option>
										</select>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Source</strong></td>
									<td>
										<select className="select" placeholder="Select">
											<option value="">Select</option>
											<option value="">Builder/Client</option>
											<option value="" selected>Cabinet Supplier</option>
											<option value="">Designer</option>
											<option value="">Another option</option>
											<option value="">More options</option>
										</select>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Issue</strong></td>
									<td>
										<select className="select" placeholder="Select">
											<option value="">Select</option>
											<option value="">Thermofoil peeling /cut short/ wrinkling</option>
											<option value="" selected>Wrong Product Sent</option>
											<option value="">Edge Tape Quality</option>
											<option value="">Another option</option>
											<option value="">More options</option>
										</select>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Description</strong></td>
									<td><textarea placeholder='Description'>Install lower shelf, center panel #11 came without glaze 70.5</textarea></td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Material</strong></td>
									<td>
										<table className='compact' cellPadding='0' cellSpacing='0'>
											<tbody>
												<tr className=''>
													<td></td>
													<td className=''>
														<select className="select" placeholder="Manufacturer">
															<option value="">Select Manufacturer</option>
															<option value="">Kitchen Craft</option>
															<option value="">Warehouse</option>
															<option value="">Another</option>
														</select>
													</td>
													<td className=''><input type='text' placeholder='Product Name' autoCapitalize='' autoCorrect='off' value='' />
													</td>
													<td className=''><input type='text' placeholder='PO Number' value='' /></td>
													<td className='action'><button className='icon iconOnly addItem'><span></span></button></td>
													<td></td>
												</tr>
												<tr className=''>
													<td></td>
													<td className=''>
														<select className="select" placeholder="Manufacturer">
															<option value="">Select Manufacturer</option>
															<option value="" selected>Kitchen Craft</option>
															<option value="">Warehouse</option>
															<option value="">Another</option>
														</select>
													</td>
													<td className=''><input type='text' placeholder='Product Name' autoCapitalize='' autoCorrect='off' value='1-WEP11' />
													</td>
													<td className=''><input type='text' placeholder='PO Number' value='56784' /></td>
													<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Estimate</strong></td>
									<td>
										<select className="select" placeholder="Estimate (optional)">
											<option value="">Estimate (optional)</option>
											<option value="">0.5 hour</option>
											<option value="">1 hour</option>
											<option value="">2 hour</option>
											<option value="">Another option</option>
											<option value="">More options</option>
										</select>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Personnel</strong></td>
									<td>
										<select className="select" placeholder="Who should resolve this? (optional)">
											<option value="">Who should resolve this? (optional)</option>
											<option value="">Bob Smith</option>
											<option value="">Darryl Philbin</option>
											<option value="">Another option</option>
											<option value="">More options</option>
										</select>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Photos</strong></td>
									<td>
										<div className="photos">
											<div className="photoControl large">
												<div className="uploadPhoto add"></div>
												<input type="file" accept="image/*" capture="environment" />
											</div>
											<div className="photoControl large">
												<div className="uploadPhoto" style={{ backgroundImage: 'url("/images/_demo_photo2.jpg")'}}></div>
											</div>
										</div>
									</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		{/* Edit Multiple Issues */}
		<div className='modal out'>
			<div className='window'>
				<header><button className='cancel'><span>Cancel</span></button><span>Edit &bull; 2 Issues</span><button className='save'><span>Save</span></button></header>
				<div className='views'>
					<div className='content in scrollable'>
						<table className='' cellPadding='0' cellSpacing='0'>
							<thead>
								<tr>
									<td></td>
									<td>Source</td>
									<td>Material</td>
									<td>P.O.</td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td>Kitchen Craft</td>
									<td>1 Item</td>
									<td className=''><input type='text' placeholder='PO Number' value='56784' /></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td>Warehouse</td>
									<td>1 Item</td>
									<td className=''><input type='text' placeholder='PO Number' value='54555' /></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		{/* Schedule Issue(s) */}
		<div className='modal out'>
			<div className='window'>
				<header><button className='cancel'><span>Cancel</span></button><span>Schedule Service &bull; 1 Issue &bull; 1 hour</span><button className='save'><span>SCHEDULE</span></button></header>
				<div className='views'>
					<div className='content in scrollable'>
						<table className='' cellPadding='0' cellSpacing='0'>
							<tbody>
								<tr>
									<td></td>
									<td><strong>Assign to</strong></td>
									<td>
										<select className="select" placeholder="Select">
											<option value="">Select</option>
											<option value="" selected>Bob Smith</option>
											<option value="">Darryl Philbin</option>
											<option value="">Another option</option>
											<option value="">More options</option>
										</select>
									</td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td><strong>Date</strong></td>
									<td>
										<div className='DayPickerInput'><input placeholder='Select' className='dataList' type='text' value='' /></div>
									</td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		{/* Context Menus - provided as a reference for button classes and labels */}

		{/* Move to Process Queue */}
		<div className='modal out'>
			<div className='popup left'>
				<div className='wedge'></div>
				<div className='container'>
					<div className='content scrollable'>
						<ul className='menu'>
							<li><a className='button icon iconLabel moveItem'><span>Move to Process Queue</span></a></li>
							<li><a className='button icon iconLabel editItem'><span>Edit Issue</span></a></li>
							<li><a className='button icon iconLabel duplicateItem'><span>Duplicate</span></a></li>
							<li><a className='button icon iconLabel removeItem delete'><span>Delete</span></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		{/* Schedule */}
		<div className='modal in'>
			<div className='popup left'>
				<div className='wedge'></div>
				<div className='container'>
					<div className='content scrollable'>
						<ul className='menu'>
							<li><a className='button icon iconLabel scheduleItem'><span>Schedule</span></a></li>
							<li><a className='button icon iconLabel editItem'><span>Edit Issue</span></a></li>
							<li><a className='button icon iconLabel duplicateItem'><span>Duplicate</span></a></li>
							<li><a className='button icon iconLabel removeItem delete'><span>Delete</span></a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>;
}